import Styles from './sectionTitle.module.css';

type SectionTitleProps = {
  title: React.ReactNode;
  /**
   * A: 標準（英字キッカー＋H2＋バー＋補足）— 通常の情報セクション
   * B: 大型見出し（H2を大きく、キッカー・バーなし）— フロー / 主要機能 など
   * C: 背景一体型（濃色背景に大きな白抜き見出し）— CTA / 差別化 など
   */
  pattern?: 'A' | 'B' | 'C';
  kicker?: string;
  lead?: React.ReactNode;
  align?: 'center' | 'left';
  /** C 用: 背景が濃色か */
  tone?: 'light' | 'dark';
  /** B 用: ひとまわり小さく（その他の機能 など補足セクション） */
  compact?: boolean;
};

const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  pattern = 'A',
  kicker,
  lead,
  align = 'center',
  tone = 'light',
  compact = false,
}) => {
  const cls = [
    Styles.head,
    Styles[`p_${pattern}`],
    Styles[`a_${align}`],
    tone === 'dark' ? Styles.dark : '',
    compact ? Styles.compact : '',
  ].join(' ');

  return (
    <div className={cls}>
      {pattern !== 'B' && kicker && <span className={Styles.kicker}>{kicker}</span>}
      <h2 className={Styles.title}>{title}</h2>
      {pattern === 'A' && <span className={Styles.bar}></span>}
      {lead && <p className={Styles.lead}>{lead}</p>}
    </div>
  );
};

export default SectionTitle;
